/**
 * Load Google Maps JavaScript API
 * Only loads once, even if called multiple times
 */

let scriptLoaded = false;
let scriptLoading = false;
let loadPromise = null;

export function loadGoogleMapsScript() {
  // Already loaded
  if (scriptLoaded) {
    return Promise.resolve();
  }

  // Currently loading
  if (scriptLoading) {
    return loadPromise;
  }

  const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  if (!apiKey) {
    console.warn('Google Maps API key not found. Set VITE_GOOGLE_MAPS_API_KEY in .env file');
    return Promise.reject(new Error('Google Maps API key not configured'));
  }

  scriptLoading = true;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      scriptLoaded = true;
      scriptLoading = false;
      console.log('Google Maps API loaded successfully');
      resolve();
    };

    script.onerror = (error) => {
      scriptLoading = false;
      console.error('Failed to load Google Maps API:', error);
      reject(error);
    };

    document.head.appendChild(script);
  });

  return loadPromise;
}
